import $ from 'jquery';

if($('body').hasClass('single-vacancies')){
	var $single_vacancy_button = $('#single-vacancy-button');
	var $form = $('.flexible-content-wrapper--content_blocks').find('form').first();
	if ($form.length > 0) {
		$single_vacancy_button.on('click', function () {
			var offset = 50;
			if (Foundation.MediaQuery.atLeast('large')) {
				offset = 88;
			}
			$('html, body').animate({
				scrollTop: $form.offset().top - offset
			}, 200);
		});
	}
	else {
		$single_vacancy_button.hide();
	}
}